import React from "react";
import "./template1.css";

const Skills = ()=>{

    return(
        <>
        <div contentEditable={true} className="skillHeading">
        <div className="skill">SKILLS</div>
            <div className="element"></div>
            <div className="userSkill">Skills comes here ... </div>
        </div>
        </>
    )
}

export default Skills;